import { render, staticRenderFns } from "./DiagramView.vue?vue&type=template&id=1fc346ed&scoped=true&"
import script from "./DiagramView.vue?vue&type=script&lang=ts&"
export * from "./DiagramView.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramView.vue?vue&type=style&index=0&id=1fc346ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc346ed",
  null
  
)

export default component.exports